<template>
  	<div class="container-fluid">
        <div class="m-2">
            <div class="alert alert-primary h4 text-center">
                <linkto :link="'/'"/>
                Ügyfél lista export
            </div>
        </div>

        <div
            class="row d-flex justify-content-center align-items-center text-center"
            v-if="filter != undefined"
        >
        <div class="col-6 col-lg-2">
	          <div class="m-2">
	          		<span class="h6">Állapot</span>
	          		<select v-model="filter.aktiv" class="form-control">
    				  		<option :value="0">Nem aktíc</option>
    				  		<option :value="1">Aktív</option>
    				  		<option :value="2">Mindkettő</option>
					       </select>
	          	</div>
            </div>

            <div class="col-6 col-md-4 col-lg-2 text-center">
                <span class="h6">Ügyfél/Érdeklődő</span>
                <select v-model="filter.inquiring" class="form-control m-1">
                    <option value="1">Érdeklődő</option>
                    <option value="0">Ügyfél</option>
                    <option value="2">Mindkettő</option>
                </select>
            </div>

	        <div class="col-6 col-lg-2">
            	<span class="h6">Régió</span>
            	<div class="input-group">
              		<input type="number" class="form-control text-center" v-model="filter.regio_kezd"></input>
              		<input type="number" class="form-control text-center" v-model="filter.regio_veg"></input>
            	</div>
	        </div>

	        <div class="col-6 col-md-4 col-lg-2 text-center">
                <span class="h6">Ügyfél kategória</span>
                <select v-model="filter.kategoria_id" class="form-control m-1">
                  	<option v-for="(item,index) in kat" :value="item.kszam">
                    	{{item.nev}}
                  	</option>
                </select>
            </div>

            <div class="col-6 col-md-4 col-lg-2 text-center">
                <span class="h6">Ügyfél típus</span>
                <select v-model="filter.tipus_id" class="form-control m-1">
                  	<option v-for="(item,index) in tip" :value="item.kszam">
                    	{{item.nev}}
                  	</option>
                </select>
            </div>
            
            <div class="col-6 col-md-4 col-lg-2 text-center">
                <span class="h6">Automata</span>
                <select v-model="filter.automataa" class="form-control m-1">
                  	<option value="0">Nincs</option>
                  	<option value="1">Van</option>
                  	<option value="2">Mindkettő</option>
                </select>
            </div>
            
            <div class="col-6 col-md-4 col-lg-2 text-center">
                <span class="h6">Automata szerződés</span>
                <select v-model="filter.automata_szerz" class="form-control m-1">
                  	<option value="0">Nincs</option>
                  	<option value="1">Van</option>
                  	<option value="2">Mindkettő</option>
                </select>
            </div>

            <!--<div class="col-6 col-md-4 col-lg-2 text-center">
                <span class="h6">Telefonszám</span>
                <select v-model="filter.tel" class="form-control m-1">
                  	<option value="0">Nincs</option>
                  	<option value="1">Van</option>
                  	<option value="2">Mindkettő</option>
                </select>
            </div>

            <div class="col-6 col-md-4 col-lg-2 text-center">
                <span class="h6">E-mail cím</span>
                <select v-model="filter.email" class="form-control m-1">
                  	<option value="0">Nincs</option>
                  	<option value="1">Van</option>
                  	<option value="2">Mindkettő</option>
                </select>
            </div>-->
	    </div>

	    <button
			class="btn btn-success"
			@click.prevent="download()"
		>
			Letöltés
		</button>
	</div>
</template>

<script type="text/javascript">

export default {
	data() {
		return {
			filter: {
				aktiv: 1,
				regio_kezd: 0,
                regio_veg: 9999,
                automataa: 2,
                automata_szerz: 2,
                kategoria_id: 0,
                tipus_id: 0,
                tel: 2,
                email: 2,
                inquiring: 2
			},
			kat: [],
            tip: []
		}
	},

	mounted(){
        this.$Progress.start()
        this.isLoading = true
        this.req.post(`/others`)
            .then(res => {
                this.kat = res.data.kat
                this.kat.splice(0,0,{ "id": 0, "kszam": 0, "nev": "Minden", "megjegyzes": null })
                this.tip = res.data.tip
                this.tip.splice(0,0,{ "id": 0, "kszam": 0, "nev": "Minden", "megjegyzes": null })
                this.$Progress.finish()
                this.isLoading = false
            })
            .catch(err => {
                this.$Progress.fail()
                this.isLoading = false
            })
    },

	methods: {
		download() {
			let user = this.$store.getters.user ? this.$store.getters.user.loginnev : null
        	let token = this.$store.getters.token ? this.$store.getters.token : null
			let url = `${this.baseURL}/customers/export?user=${user}&token=${token}`
            this.$Progress.start()
            this.isLoading = true
            this.req.post(url, {
              filter: this.filter
            }, { responseType: 'blob' } )
              .then(res => {
                  const url = window.URL.createObjectURL(new Blob([res.data]))
                  const link = document.createElement('a')
                  link.href = url
                  link.setAttribute('download', `ugyfel_export.xls`)
                  document.body.appendChild(link)
                  link.click()
                  this.$Progress.finish()
                  this.isLoading = false
              })
              .catch(err => {
                  toastr.error(err.response.data.text || 'hiba a letöltésben')
                  this.$Progress.fail()
                  this.isLoading = false
              })
        },

	}
}
</script>


// WEBPACK FOOTER //
// src/components/customers/export.vue